module.exports = __webpack_public_path__ + "img/product-preview-85.036308d.png";